import { z } from 'zod';
import { ISODateTimeSchema, UUIDSchema } from './common';
import { RootUserSchema } from './user';
export const AnnotationMessageSchema = z.object({
    uuid: UUIDSchema.optional(),
    text: z.string(),
    created_by: z.number().optional(),
    updated_on: ISODateTimeSchema.optional(),
    created_on: ISODateTimeSchema.optional(),
    is_edited: z.boolean().optional(),
    is_deleted: z.boolean().optional(),
    is_read_only: z.boolean().optional(),
    original_draft_uuid: UUIDSchema.optional(),
    original_draft_title: z.string().optional(),
});
const AnnotationBaseSchema = AnnotationMessageSchema.extend({
    replies: z.array(AnnotationMessageSchema).optional(),
});
export const ScaledSchema = z.object({
    x: z.number(),
    y: z.number(),
    width: z.number(),
    height: z.number(),
    page_number: z.number(),
});
export const TextSelectionSchema = z.object({
    text: z.string(),
    rects: z.array(ScaledSchema),
});
export const PdfAnnotationSchema = AnnotationBaseSchema.extend({
    annotation_type: z.literal('pdf'),
    page_number: z.number(),
    selection: TextSelectionSchema.optional(),
});
export const DeviationAnnotationSchema = AnnotationBaseSchema.extend({
    annotation_type: z.literal('deviation'),
    row_reference: z.string(),
});
export const GeneralAnnotationSchema = AnnotationBaseSchema.extend({
    annotation_type: z.literal('general'),
});
export const AnnotationSchema = z.discriminatedUnion('annotation_type', [
    PdfAnnotationSchema,
    DeviationAnnotationSchema,
    GeneralAnnotationSchema,
]);
export const PlausibilitySchema = z.object({
    annotations: z.array(AnnotationSchema),
    parent_draft_uuid: UUIDSchema,
    is_handed_over: z.boolean(),
    handed_over_on: ISODateTimeSchema.optional(),
    handed_over_by: UUIDSchema.optional(),
    is_approved: z.boolean(),
    approved_on: ISODateTimeSchema.optional(),
    approved_by: UUIDSchema.optional(),
    is_internally_approved: z.boolean().optional(),
    internally_approved_on: ISODateTimeSchema.optional(),
    internally_approved_by: UUIDSchema.optional(),
    participant_ids: z.array(z.number()),
    participant_users: z.array(RootUserSchema),
});
